import { CoursesPickerView } from './courses-picker.component';
import { withCourses } from '../../courses/components/courses.container';

export const CoursesPicker = withCourses(CoursesPickerView);
